import { PanelDeEmision } from "@/components/generacion/PanelDeEmision";
import { RevisionDeCalidad } from "@/components/generacion/RevisionDeCalidad";
import { VistaPreviaDelDocumento } from "@/components/generacion/VistaPreviaDelDocumento";
import { useCatalogosDelInforme } from "@/hooks/useInformes";
import type { CondicionesDeEmision, DestinoDeLaCondicion, Emision } from "@/lib/emision";
import type { Informe } from "@/lib/informes";

interface DocumentoDelInformeProps {
  informe: Informe;
  condiciones: CondicionesDeEmision | undefined;
  cargandoCondiciones: boolean;
  emisiones: Emision[];
  onIr: (destino: DestinoDeLaCondicion) => void;
}

/**
 * La fase 4: emitir el documento. A la izquierda lo que falta y el botón de
 * emitir; a la derecha el documento real en borrador; abajo la revisión de
 * calidad. Las condiciones y las versiones las trae la pantalla (el carril
 * también las lee), así que acá solo se dibujan.
 */
export function DocumentoDelInforme({
  informe,
  condiciones,
  cargandoCondiciones,
  emisiones,
  onIr,
}: DocumentoDelInformeProps) {
  const catalogos = useCatalogosDelInforme();
  const plantilla = catalogos.data?.plantillas.find((p) => p.id === informe.plantilla?.id);
  const formatos = plantilla?.formatos ?? [];
  const formatoActual = informe.formato_salida ?? null;

  return (
    <div className="space-y-4">
      <div className="grid items-start gap-4 xl:grid-cols-[minmax(0,21.25rem)_minmax(0,1fr)]">
        <PanelDeEmision
          informeId={informe.id}
          formatos={formatos}
          formatoActualId={formatoActual?.id ?? null}
          condiciones={condiciones}
          cargandoCondiciones={cargandoCondiciones}
          emisiones={emisiones}
          onIr={onIr}
        />
        <VistaPreviaDelDocumento
          informeId={informe.id}
          condiciones={condiciones}
          emisiones={emisiones}
          formatoNombre={formatoActual?.nombre ?? null}
          nombreDelArchivo={`borrador-${informe.numero_informe ?? informe.id}.pdf`}
        />
      </div>

      <RevisionDeCalidad informeId={informe.id} condiciones={condiciones} />
    </div>
  );
}
